import React from 'react';

interface MiniCardProps {
  text1?: string;
  text2?: string;
  text3?:string;
  icon?: JSX.Element;
}

const defaultProps: MiniCardProps = {
  text1: '',
  icon: <></>,
  text2: '',
  text3: '',
};
export const MiniCard = ({ text1, text2, text3, icon }: MiniCardProps = defaultProps): JSX.Element => {
  return (
    <div className="relative">
      <div className="inline-flex flex-col items-center justify-center relative rounded-[4px]">
        {icon}

        <div className="flex flex-col items-center mt-[0.5em] justify-center gap-2 relative bg-[#fff4c6] p-2 rounded-[4px]">
          <div className="absolute w-4 h-4  bg-[#fff4c6] top-[-6px] left-1/2 transform -translate-x-2 rotate-45"></div>
          <p className="text-start w-64 md:w-64 lg:w-[394px] mt-2 font-medium text-[#5a5a5a] text-[16px] tracking-[0] leading-[normal] pl-2">
            {text1}
          </p>
          <p className="text-start w-64 md:w-64 lg:w-[394px] mt-2 font-medium text-[#5a5a5a] text-[16px] tracking-[0] leading-[normal] pl-2">
            {text2}
          </p>
          <p className="text-start w-64 md:w-64 lg:w-[394px] mt-2 font-medium text-[#5a5a5a] text-[16px] tracking-[0] leading-[normal] pl-2">
            {text3}
          </p>
        </div>
      </div>
    </div>
  );
};

